import { CtouchLogoLaNo } from '../../../../assets/img/logos/CtouchLogoLaNo.jsx'
import { CtouchLogoLaYes } from '../../../../assets/img/logos/CtouchLogoLaYes.jsx'
import { CtouchLogoBoNo } from '../../../../assets/img/logos/CtouchLogoBoNo.jsx'
import { CtouchLogoBoYes } from '../../../../assets/img/logos/CtouchLogoBoYes.jsx'
import { CtouchLogoHpNo } from '../../../../assets/img/logos/CtouchLogoHpNo.jsx'
import { CtouchLogoHpYes } from '../../../../assets/img/logos/CtouchLogoHpYes.jsx'
import { CtouchLogoPhNo } from '../../../../assets/img/logos/CtouchLogoPhNo.jsx'
import { CtouchLogoPhYes } from '../../../../assets/img/logos/CtouchLogoPhYes.jsx'
import { CtouchLogoWhYes } from '../../../../assets/img/logos/CtouchLogoWhYes.jsx'
import { CtouchLogoWhNo } from '../../../../assets/img/logos/CtouchLogoWhNo.jsx'
import { CtouchLogoBlYes } from '../../../../assets/img/logos/CtouchLogoBlYes.jsx'
import { CtouchLogoBlNo } from '../../../../assets/img/logos/CtouchLogoBlNo.jsx'

import CtouchLogoColor from '../../../../enums/CtouchLogoColor'

function CtouchLogo(props) {
    const logo = getLogo(props);
    return logo;
}

const getLogo = (props) => {
    switch (props.color) {
        case CtouchLogoColor.lifeAquatic:
            return (
                props.hasPayOff ? <CtouchLogoLaYes className={props.className} /> : <CtouchLogoLaNo className={props.className} />
            );
        case CtouchLogoColor.bloodOrange:
            return (
                props.hasPayOff ? <CtouchLogoBoYes className={props.className} /> : <CtouchLogoBoNo className={props.className} />
            );
        case CtouchLogoColor.hotPink:
            return (
                props.hasPayOff ? <CtouchLogoHpYes className={props.className} /> : <CtouchLogoHpNo className={props.className} />
            );
        case CtouchLogoColor.purpleHaze:
            return (
                props.hasPayOff ? <CtouchLogoPhYes className={props.className} /> : <CtouchLogoPhNo className={props.className} />
            );
        case CtouchLogoColor.white:
            return (
                props.hasPayOff ? <CtouchLogoWhYes className={props.className} /> : <CtouchLogoWhNo className={props.className} />
            );
        case CtouchLogoColor.black:
            return (
                props.hasPayOff ? <CtouchLogoBlYes className={props.className} /> : <CtouchLogoBlNo className={props.className} />
            );
        default: return <CtouchLogoLaYes className={props.className} />;
    }
}

export default CtouchLogo;